import React, { useEffect, useRef } from 'react';
import { BrowserRouter, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { StudioProvider } from './contexts/StudioContext';
import { AdminAuthProvider } from './contexts/AdminAuth';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { MobileTabBar } from './components/layout/MobileTabBar';
import { AdminShell } from './components/admin/AdminShell';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { Work } from './pages/Work';
import { Studio } from './pages/Studio';
import { Book } from './pages/Book';
import { Appointment } from './pages/Appointment';
import { Contact } from './pages/Contact';
import { Dashboard } from './pages/admin/Dashboard';
import { Agenda } from './pages/admin/Agenda';
import { BookingsAdmin } from './pages/admin/BookingsAdmin';
import { ServicesAdmin } from './pages/admin/ServicesAdmin';
import { AvailabilityAdmin } from './pages/admin/AvailabilityAdmin';
function PublicLayout() {
  const {
    pathname
  } = useLocation();
  const scroller = useRef<HTMLDivElement>(null);
  useEffect(() => {
    document.body.style.overflow = '';
    scroller.current?.scrollTo({
      top: 0
    });
    window.scrollTo({
      top: 0
    });
  }, [pathname]);
  return <div className="app-shell flex-col bg-void" data-id="element-0" data-mp="6hovayao7c0">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-ember focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-void" data-id="element-1" data-mp="56l3b4umzkw">
        Naar hoofdinhoud
      </a>
      <Header data-id="element-2" data-mp="38l05i12awv78" />
      <div ref={scroller} id="main" className="app-scroll" data-id="element-3" data-mp="38kgkgbhctqoz">
        <main className="min-w-0" data-id="element-4" data-mp="3dl4l7ovdxlwe">
          <Outlet data-id="element-5" data-mp="3dm5z013scmht" />
        </main>
        <Footer data-id="element-6" data-mp="nvj3jfxq0epq" />
      </div>
      <MobileTabBar data-id="element-7" data-mp="nwc1psim5vw9" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-8" data-mp="sudksdg1hv7q">
      <StudioProvider data-id="element-9" data-mp="stuexv3nyxa2">
        <AdminAuthProvider data-id="element-10" data-mp="stc7017n2umb">
          <Routes data-id="element-11" data-mp="swqbbezv5dwe">
            <Route path="/admin" element={<AdminShell data-id="element-13" data-mp="35ovimiemwr0" />} data-id="element-12" data-mp="36hzxgtw5a5z">
              <Route index element={<Dashboard data-id="element-15" data-mp="38b5stwojqcx" />} data-id="element-14" data-mp="34x4lozr5n72" />
              <Route path="agenda" element={<Agenda data-id="element-17" data-mp="3ubzrw5cgz9c0" />} data-id="element-16" data-mp="3udaw269tuj3n" />
              <Route path="bookings" element={<BookingsAdmin data-id="element-19" data-mp="d4e4fpsbp6v4" />} data-id="element-18" data-mp="3uevs60bsia3m" />
              <Route path="services" element={<ServicesAdmin data-id="element-21" data-mp="d2l936n5u92f" />} data-id="element-20" data-mp="d3cu5nj4soeg" />
              <Route path="availability" element={<AvailabilityAdmin data-id="element-23" data-mp="86w58r43y60b" />} data-id="element-22" data-mp="85ully910b6z" />
            </Route>

            <Route element={<PublicLayout data-id="element-25" data-mp="3gkl9o0qdzc60" />} data-id="element-24" data-mp="3gl4r7gc4jyji">
              <Route path="/" element={<Home data-id="element-27" data-mp="3gja35t5k3qb7" />} data-id="element-26" data-mp="3glwbvw46obv0" />
              <Route path="/services" element={<Services data-id="element-29" data-mp="3bncso3gz5e6c" />} data-id="element-28" data-mp="3bmjsjlcitmx6" />
              <Route path="/work" element={<Work data-id="element-31" data-mp="3qb7m5m2t3mkh" />} data-id="element-30" data-mp="3bo4isyrsyjp8" />
              <Route path="/studio" element={<Studio data-id="element-33" data-mp="3qcqzb3t61hi1" />} data-id="element-32" data-mp="3qbfvj3zq09qx" />
              <Route path="/book" element={<Book data-id="element-35" data-mp="3ljxtsdpvi54w" />} data-id="element-34" data-mp="3qd0tl3l8uatj" />
              <Route path="/appointment" element={<Appointment data-id="element-37" data-mp="3liefgsns245r" />} data-id="element-36" data-mp="3ljphamxnx1u8" />
              <Route path="/contact" element={<Contact data-id="element-39" data-mp="2xtlqjg5kowkn" />} data-id="element-38" data-mp="2xudatutpz7vm" />
              <Route path="*" element={<Home data-id="element-41" data-mp="2svtqtzyos65w" />} data-id="element-40" data-mp="2xssgo6bbhqya" />
            </Route>
          </Routes>
        </AdminAuthProvider>
      </StudioProvider>
    </BrowserRouter>;
}